/* eslint-disable no-unused-vars */
import React, { useState } from "react";

/* PACKAGES */
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

/* ANIMATION */
import { containerAnimation, animation } from "../utils/animation";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
  Collapse,
} from "@material-tailwind/react";

/* DATA */
import { shopByCategory, shopByBrand, shopByName } from "../data/fakeDB";

/* ICONS */
import { IoBagHandle, IoHeart, IoPerson, IoSearch } from "react-icons/io5";
import { Bars2Icon } from "@heroicons/react/24/outline";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  /* CATEGORY ACCORDION */
  const [categoryAccordion, setCategoryAccordion] = useState(false);

  return (
    <>
      <motion.header
        variants={containerAnimation}
        initial="hidden"
        animate="visible"
        className="header-shadow w-full z-50 relative"
      >
        {/* TOP HEADER */}
        <motion.div variants={animation} className="bg-primaryRed py-2">
          <div className="container">
            <p className="text-base font-source font-semibold text-white text-center uppercase">
              The products on this website contain nicotine. Nicotine is an
              addictive chemical.
            </p>
          </div>
        </motion.div>

        {/* BOTTOM HEADER */}
        <motion.div
          variants={animation}
          className={`py-2 bg-white header-shadow`}
        >
          <div className="container">
            <div className="grid grid-cols-2 xl:grid-cols-5 lg:grid-cols-5 items-center">
              {/* LOGO */}
              <div className="col-span-1 flex xl:block lg:block items-center gap-5 xl:gap-0 lg:gap-0">
                <Button
                  className="bg-transparent shadow-none hover:shadow-none border border-[#E5E5E5] p-2 rounded-full hover:bg-black hover:bg-opacity-10 block xl:hidden lg:hidden"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  <Bars2Icon className="w-4 h-4 text-black" />
                </Button>
                <Link to="/">
                  <img
                    src={require("../assets/images/westcoast-wholesale-logo.png")}
                    className="h-24 w-auto object-contain"
                    alt="West Cost Wholesale"
                  />
                </Link>
              </div>

              {/* NAVIGATION LINKS */}
              <div className="col-span-3 hidden xl:block lg:block">
                <div className="flex items-center justify-center gap-10">
                  {/* SHOP BY CATEGORY */}
                  <Menu allowHover>
                    <MenuHandler>
                      <p className="text-base text-black font-source font-semibold cursor-pointer hover:text-primaryRed transition-all duration-300 ease-in-out">
                        Shop by Category
                      </p>
                    </MenuHandler>
                    <MenuList className="w-[20vh] p-2 hover:outline-none rounded-lg">
                      {shopByCategory.map((data, index) => (
                        <MenuItem
                          onClick={() => {
                            navigate("/shop");
                          }}
                          className="group py-2 px-3 bg-transparent text-base font-source font-medium text-black hover:bg-primary hover:bg-opacity-20"
                          key={index}
                        >
                          {data.category}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Menu>

                  {/* SHOP BY BRAND */}
                  <Menu allowHover>
                    <MenuHandler>
                      <p className="text-base text-black font-source font-semibold cursor-pointer hover:text-primaryRed transition-all duration-300 ease-in-out">
                        Shop by Brand
                      </p>
                    </MenuHandler>
                    <MenuList className="w-[20vh] p-2 hover:outline-none rounded-lg">
                      {shopByBrand.map((data, index) => (
                        <MenuItem
                          onClick={() => {
                            navigate("/shop");
                          }}
                          className="group py-2 px-3 bg-transparent text-base font-source font-medium text-black hover:bg-primary hover:bg-opacity-20"
                          key={index}
                        >
                          {data.brand}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Menu>

                  {/* SHOP BY NAME */}
                  <Menu allowHover>
                    <MenuHandler>
                      <p className="text-base text-black font-source font-semibold cursor-pointer hover:text-primaryRed transition-all duration-300 ease-in-out">
                        Shop by Name
                      </p>
                    </MenuHandler>
                    <MenuList className="w-[20vh] p-2 hover:outline-none rounded-lg">
                      {shopByName.map((data, index) => (
                        <MenuItem
                          onClick={() => {
                            navigate("/shop");
                          }}
                          className="group py-2 px-3 bg-transparent text-base font-source font-medium text-black hover:bg-primary hover:bg-opacity-20"
                          key={index}
                        >
                          {data.name}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Menu>
                </div>
              </div>

              {/* USER OPTIONS */}
              <div className="col-span-1">
                <div className="flex items-center justify-end gap-2 xl:gap-3 lg:gap-3">
                  {/* SEARCH */}
                  <div className="block bg-greyBg hover:bg-black hover:bg-opacity-10 rounded-full p-2 xl:p-3 lg:p-2 transition-all duration-300 ease-in-out cursor-pointer">
                    <IoSearch className="w-5 h-5 text-black" />
                  </div>

                  {/* MY ACCOUNT */}
                  <Link to="/login" className="block">
                    <div className="block bg-greyBg hover:bg-black hover:bg-opacity-10 rounded-full p-2 xl:p-3 lg:p-3 transition-all duration-300 ease-in-out cursor-pointer">
                      <IoPerson className="w-5 h-5 text-black" />
                    </div>
                  </Link>

                  {/* WISHLIST */}
                  <Link
                    to="/wishlist"
                    className="block bg-greyBg hover:bg-black hover:bg-opacity-10 rounded-full p-2 xl:p-3 lg:p-3 relative transition-all duration-300 ease-in-out"
                  >
                    <IoHeart className="w-5 h-5 text-black" />
                    <div className="w-4 h-4 bg-primaryRed rounded-full absolute top-0 xl:top-0 lg:top-0 right-0 xl:right-0 lg:right-0 flex items-center justify-center">
                      <p className="text-xxs font-source font-semibold text-white">
                        0
                      </p>
                    </div>
                  </Link>

                  {/* MY BAG */}
                  <Link
                    to="/my-bag"
                    className="block bg-greyBg hover:bg-black hover:bg-opacity-10 rounded-full p-2 xl:p-3 lg:p-3 relative transition-all duration-300 ease-in-out"
                  >
                    <IoBagHandle className="w-5 h-5 text-black" />
                    <div className="w-4 h-4 bg-primaryRed rounded-full absolute top-0 xl:top-0 lg:top-0 right-0 xl:right-0 lg:right-0 flex items-center justify-center">
                      <p className="text-xxs font-source font-semibold text-white">
                        1
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* MOBILE MENU */}
        <Collapse
          open={menuOpen}
          placement="bottom"
          animate={{
            mount: { opacity: 1, y: 0 },
            unmount: { opacity: 0, y: 25 },
          }}
        >
          <div className="p-5 bg-white border-t border-greyBorder z-20">
            {/* SHOP BY CATEGORY */}
            <div
              className="flex items-center gap-2 text-black font-source font-semibold text-base hover:text-logo"
              onClick={() => setCategoryAccordion(!categoryAccordion)}
            >
              Shop by Category
              {categoryAccordion ? (
                <MdKeyboardArrowDown className="w-4 h-4 text-black" />
              ) : (
                <MdKeyboardArrowRight className="w-4 h-4 text-black" />
              )}
            </div>
            <Collapse open={categoryAccordion}>
              <div className="ml-3">
                {shopByCategory.map((data) => (
                  <Link
                    href={data.route}
                    key={data.id}
                    className="block text-base text-black font-source font-semibold transition-all duration-300 ease-in-out mt-3 xl:mt-0 lg:mt-0"
                  >
                    {data.label}
                  </Link>
                ))}
              </div>
            </Collapse>
          </div>
        </Collapse>
      </motion.header>
    </>
  );
};

export default Header;
